// removed by extract-text-webpack-plugin
module.exports = {"root":"_2Selq","field":"_29Ejs","textarea_footer":"_3Qt5A","textarea_item":"_1SDYi","textarea_template":"_3vzQe","letters":"_1yHG6","flag_img":"_2I6rh","textarea_checkbox":"_3oLE6","textarea_label":"ztHZj","textarea_input":"nB0mK"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Textarea/Textarea.css
// module id = 820
// module chunks = 0